import {Checkbox, Tooltip} from "@mui/material";
import React from "react";
import {lightenColor} from "../../helpers/ColorUtils";
import {ACCREDITATION_STATUS} from "../../domain/AccreditationStatus";

export default function AccreditationCheckBox({content, handleAccreditationUpdate, serviceTypeHierarchyMap, contentInfoAccreditationMap}) {

    const {FULL_ACCREDITATION, PARTIAL_ACCREDITATION} = ACCREDITATION_STATUS;
    const isFullyAccredited = (content.value === FULL_ACCREDITATION);
    const isPartiallyAccredited = (content.value === PARTIAL_ACCREDITATION);

    const style = {
        color: isPartiallyAccredited ? lightenColor(content.row.primaryColor) : content.row.primaryColor,
        flex: '1 0 100%'
    };

    return <Tooltip title={content.value}>
        <Checkbox
          checked={isFullyAccredited}
          indeterminate={isPartiallyAccredited}
          style={style}
          onChange={event => handleAccreditationUpdate(event, content, serviceTypeHierarchyMap, contentInfoAccreditationMap)} />
    </Tooltip>
}
